/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DiscountCapability {
    DISCOUNT_REMOVE = 'discount:remove',
}
